export default "__VITE_PUBLIC_ASSET__3882993d__"